// extracted by mini-css-extract-plugin
export default {"skeleton":"style_skeleton__M05nu"};